var map = {
	"./app.svg": 20895,
	"./casino.svg": 48282,
	"./jackpotTabBar.svg": 29118,
	"./lobby.svg": 74447,
	"./profile.svg": 81459,
	"./promo.svg": 13052,
	"./quest.svg": 84342,
	"./signout.svg": 44137,
	"./sports.svg": 13549,
	"./sportsMobileMenuIcon.svg": 9261,
	"./tournaments.svg": 1296,
	"./vip.svg": 35150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59031;